import { gsap } from "gsap"
import { ScrambleTextPlugin } from "gsap/ScrambleTextPlugin"

gsap.registerPlugin(ScrambleTextPlugin);

const titleElement = document.querySelector('.p-home-keyvisual__title');

if (titleElement) {
    const originalTitleHTML = titleElement.innerHTML;
    const originalTitleText = titleElement.textContent.trim();
    titleElement.style.visibility = 'hidden';

    const startAnimation = () => {
        titleElement.style.visibility = 'visible';
        titleElement.textContent = ''; // テキストを一旦空にする

        const isSp = window.innerWidth <= 768;
        const extraDelay = isSp ? 1.5 : 0;

        // テキストアニメーションの遅延調整
        if (isSp) {
            const textElement = document.querySelector('.p-home-keyvisual__text');
            if (textElement) {
                const spans = textElement.querySelectorAll('span');
                spans.forEach(span => {
                    // transitionDelayは "0.1s" のような文字列で返る
                    const currentDelayStr = span.style.transitionDelay || window.getComputedStyle(span).transitionDelay;
                    const currentDelay = parseFloat(currentDelayStr) || 0;
                    span.style.transitionDelay = `${currentDelay + extraDelay}s`;
                });
            }
        }

        gsap.to(titleElement, {
            delay: extraDelay,
            duration: 2, // アニメーション時間
            scrambleText: {
                text: originalTitleText,
                chars: "■▪▌▐▬",
                revealDelay: 0.5,
                speed: 0.4
            },
            ease: "none",
            onUpdate: function() {
                const chars = "■▪▌▐▬";
                const regex = new RegExp(`[${chars}]`, 'g');
                this.targets()[0].innerHTML = this.targets()[0].textContent.replace(regex, (match) => `<span class="scrambling-text">${match}</span>`);
            },
            onComplete: function() {
                this.targets()[0].innerHTML = originalTitleHTML;
            }
        });
    }

    if (document.body.classList.contains('is-animation-ready')) {
        startAnimation();
    } else {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (document.body.classList.contains('is-animation-ready')) {
                        startAnimation();
                        observer.disconnect(); // Stop observing once the class is added
                    }
                }
            }
        });

        observer.observe(document.body, { attributes: true });
    }
}
